import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreInitiativesSonarObjectsDeleteAsyncSlice } from './delete';
import { coreInitiativesSonarObjectsGetAsyncSlice } from './get';
import { coreInitiativesSonarObjectsPostAsyncSlice } from './post';

export const coreInitiativesSonarObjectsReducers = combineReducers({
	delete: coreInitiativesSonarObjectsDeleteAsyncSlice.asyncReducers,
	get: coreInitiativesSonarObjectsGetAsyncSlice.asyncReducers,
	post: coreInitiativesSonarObjectsPostAsyncSlice.asyncReducers
});

export const coreInitiativesSonarObjectsWatchers = combineAllWatchers([
	coreInitiativesSonarObjectsDeleteAsyncSlice.asyncWatchers,
	coreInitiativesSonarObjectsGetAsyncSlice.asyncWatchers,
	coreInitiativesSonarObjectsPostAsyncSlice.asyncWatchers
]);
